// 新闻管理
const goodsManage = () => import('@/view/goods/goods-manage'); // 产品管理
const good = () => import('@/view/goods/good'); // 产品详情
const goodLabel = () => import('@/view/goods/good-label'); // 产品标签
const goodComponent = () => import('@/view/goods/good-component'); // 产品成分
const brandManage = () => import('@/view/goods/brand-manage'); // 品牌管理
const brandDetail = () => import('@/view/goods/brand-detail'); // 品牌详情
const statistics = () => import('@/view/goods/statistics'); // 
const sampleManage = () => import('@/view/goods/sample-manage'); // 样品管理
const sample = () => import('@/view/goods/sample'); // 样品详情
const paramsSetting = () => import('@/view/goods/params-setting'); // 样品管理
const aiProductSettings = () => import('@/view/goods/ai-product-settings');

export default [{
        path: '/ai-product-settings',
        name: 'aiProductSettings',
        component: aiProductSettings
    }, {
        path: '/good',
        name: 'good',
        component: good
    }, 
    {
        path: '/good-label',
        name: 'goodLabel',
        component: goodLabel
    }, 
    {
        path: '/good-component',
        name: 'goodComponent',
        component: goodComponent
    },
    {
        path: '/goods-manage',
        name: 'goodsManage',
        component: goodsManage
    }, {
        path: '/brand-manage',
        name: 'brandManage',
        component: brandManage
    },
    {
        path: '/brand-detail',
        name: 'brandDetail',
        component: brandDetail
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: statistics
    },
    {
        path: '/sample-manage',
        name: 'sampleManage',
        component: sampleManage
    },
    {
        path: '/sample',
        name: 'sample',
        component: sample
    },
    {
        path: '/params-setting',
        name: 'paramsSetting',
        component: paramsSetting
    }
];
